import { render, staticRenderFns } from "./Steppers.vue?vue&type=template&id=70796746&scoped=true"
import script from "./Steppers.vue?vue&type=script&lang=js"
export * from "./Steppers.vue?vue&type=script&lang=js"
import style0 from "./Steppers.vue?vue&type=style&index=0&id=70796746&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70796746",
  null
  
)

export default component.exports